import React, { useContext, useState, useEffect } from "react";
import "../styles/subShipping.css";
import appConst from "../Utilities/appConst.json";
import { LanguageContext } from "../context/language/LanguageContext";
import {
  fetchAllShopsCollectionPoints,
  shopsActions,
} from "../store/shopsSlice";
import { useDispatch, useSelector } from "react-redux";
import { disableButton, enableButton } from "../Utilities/styleUtil";
import { FloatingLabelAutocomplete } from "./ui/floating-label-autocomplete";
import { getLanguageDirection } from "../Utilities/languageDirection";
import "../styles/personalDetails.css";
import { loaderActions } from "../store/loaderSlice";
import { writeLog } from "../Utilities/logs";

const Shops = (props) => {
  const dispatch = useDispatch();
  const languageContext = useContext(LanguageContext);
  const cities = useSelector((state) => state.shops.cities);
  const collectionPoints = useSelector((state) => state.shops.collectionPoints);
  const isFormSubmited = useSelector((state) => state.shops.isFormSubmited);
  const deliveryDetails = useSelector(
    (state) => state.basket.basket.delivery_details
  );

  const [city, setCityName] = useState(
    deliveryDetails.shop ? deliveryDetails.shop?.city : null
  );
  const [address, setAddress] = useState("");
  const [site, setSiteName] = useState(
    deliveryDetails.shop ? deliveryDetails.shop?.site : null
  );
  const [showCityError, setShowCityError] = useState(
    !deliveryDetails.shop?.city
  );
  const [showCollectingPointsError, setShowCollectingPointsError] = useState(
    !deliveryDetails.shop?.site
  );

  useEffect(() => {
    disableButton(dispatch);
    dispatch(loaderActions.loaderShow());
  }, []);

  useEffect(() => {
    if (cities.length > 0) {
      dispatch(loaderActions.loaderHide());
    }
  }, [cities]);

  const resetCity = () => {
    setCityName("");
    setShowCityError(true);
    setShowCollectingPointsError(true);
    dispatch(
      shopsActions.setIsValid({
        isValid: false,
      })
    );
  };

  const resetSite = () => {
    setSiteName("");
    setAddress("");
    setShowCollectingPointsError(true);
    disableButton(dispatch);
    dispatch(shopsActions.setIsValid({ isValid: false }));
  };

  const setCity = (city) => {
    if (city && cities.filter((elenent) => elenent === city).length) {
      if (city) {
        dispatch(fetchAllShopsCollectionPoints(city));
      }
      setCityName(city);
      setShowCityError(!city);
      dispatch(shopsActions.setCity({ city: city }));
      dispatch(
        shopsActions.setIsValid({
          isValid: !!city && !showCollectingPointsError,
        })
      );
    } else {
      resetCity();
    }
    resetSite();
    writeLog({ message: `message: city is set to: ${city}` });
  };

  const setSite = (siteName) => {
    if (
      siteName &&
      collectionPoints
        .map((collectionPoint) => collectionPoint.SiteName)
        .filter((elenent) => elenent === siteName).length
    ) {
      setSiteName(siteName);
      dispatch(shopsActions.setSite({ site: siteName }));
      setShowCollectingPointsError(!siteName);
      dispatch(
        shopsActions.setIsValid({ isValid: !showCityError && !!siteName })
      );

      // SiteId
      const collectionPointsArray = Object.entries(collectionPoints);
      const siteObjectArray = collectionPointsArray.filter(
        ([k, v]) => v.SiteName === siteName
      );
      const siteObject =
        siteObjectArray &&
        siteObjectArray.length > 0 &&
        siteObjectArray[0] &&
        siteObjectArray[0].length > 1 &&
        siteObjectArray[0][1]
          ? siteObjectArray[0][1]
          : [];
      const siteId = siteObject.SiteId;
      dispatch(shopsActions.setSiteId({ siteId: siteId }));
      console.log("siteId", siteId);

      // Adress
      const address = siteObject.Address;
      setAddress(address);

      // Next Button enable/disable
      if (!!siteName) {
        enableButton(dispatch);
      } else {
        disableButton(dispatch);
      }
    } else {
      resetSite();
    }
    writeLog({ message: `message: site is set to: ${siteName}` });
  };

  const fieldDirection = getLanguageDirection(languageContext.language?.id);

  return (
    <div className="shops page personal_details sub_shipping_selects text-start mt-6">
      <div className="selections">
        <div className="selection">
          <FloatingLabelAutocomplete
            id="shipping-shops-city"
            label={languageContext.getTranslation(appConst.SELECT_CITY)}
            required
            invalid={isFormSubmited && showCityError}
            errorText={
              isFormSubmited && showCityError
                ? languageContext.getTranslation(
                    appConst.VALIDATION_SELECT_CITY_REQUIRED_FIELD
                  )
                : undefined
            }
            dir={fieldDirection}
            value={city || ""}
            options={cities.filter((city) => city != "")}
            onValueChange={setCity}
            filterFromStart
            dataTestId="shipping-shops-city"
          />
        </div>
        <div className="selection">
          <FloatingLabelAutocomplete
            id="shipping-shops-collection-point"
            label={languageContext.getTranslation(appConst.SELECT_COLLECTING_POINT)}
            required
            invalid={isFormSubmited && showCollectingPointsError}
            errorText={
              isFormSubmited && showCollectingPointsError
                ? languageContext.getTranslation(
                    appConst.VALIDATION_SELECT_COLLECTING_POINT_REQUIRED_FIELD
                  )
                : undefined
            }
            disabled={!city}
            dir={fieldDirection}
            value={site || ""}
            options={collectionPoints.map(
              (collectionPoint) => collectionPoint.SiteName
            )}
            onValueChange={setSite}
            filterFromStart
            dataTestId="shipping-shops-collection-point"
          />
        </div>
      </div>
      <div className="address_container">
        {address && (
          <div className="address text-start" data-testid="shipping-shops-address">
            <p>{languageContext.getTranslation(appConst.ADDRESS)}:</p>
            <p>{address}</p>
          </div>
        )}
      </div>
    </div>
  );
};
export default Shops;
